// src/features/auth/login-schema.ts
import { z } from 'zod';

/**
 * `.min(1)` before `.email()` on purpose.
 *
 * Zod's `.email()` also fails on an empty string, so a single email rule
 * answered "invalid" to somebody who had typed nothing — while the password
 * field one line below already said "required" for exactly that. Two rules for
 * the same situation, on the same form, a line apart.
 *
 * Chained, each case gets its own sentence: empty is missing, present-and-wrong
 * is malformed.
 *
 * The wording follows the label directly above the field, which is what
 * somebody is looking at while they read the error.
 */
export const credentialsSchema = z.object({
  email: z.string().min(1, 'Requerido').email('Correo inválido'),
  password: z.string().min(1, 'Requerido'),
});
export type CredentialsValues = z.infer<typeof credentialsSchema>;
